import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Form, Grid, Icon, Modal } from "semantic-ui-react";
import { addPlayersToWatch } from "../../store/actions/athleteActions";
import PlayersDropdown from "../athletes/PlayersDropdown";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { BsFillPatchCheckFill } from "react-icons/bs";
import { uid } from "uid";

const NewPlayersToWatch = (props) => {
  const [fields, setFields] = useState([]);
  const [confirmationPopup, setConfirmationPopup] = useState(null);
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [close, setClose] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [error, setError] = useState(false);
  const [warning, setWarning] = useState(false);
  const youtubeRegex =
    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

  useEffect(() => {
    if (props.DataplayersToWatch) {
      setData(props.DataplayersToWatch.playerstowatch);
    }
  }, [props.DataplayersToWatch]);

  useEffect(() => {
    if (data) {
      let storingObject = Object.keys(data);
      let object = [];
      if (storingObject.length > 0) {
        object = storingObject.map((key) => {
          return { key, player: data[key].player, url: data[key].url };
        });
      } else {
        object.push({ key: uid(8), player: "", url: "" });
      }
      setFields(object);
    }
  }, [data]);

  const handleSubmit = () => {
    let fieldsArray = [...fields];
    const arrayObject = fieldsArray.filter(
      (field) => field.player && field.url
    );
    fieldsArray = arrayObject;
    if (!error) {
      dispatch(addPlayersToWatch(fieldsArray));
      setClose(props.close);
      setTimeout(() => {
        props.onClose();
      }, 1000);
    }
  };

  const handleDropdownChange = (data, index) => {
    let fieldsArray = [...fields];
    if (data.value) {
      fieldsArray[index].player = data.value;
      setFields(fieldsArray);
      setError(false);
    } else {
      setError("Please select player from dropdown");
    }
  };
  const handleUrlChange = (data, index) => {
    let fieldsArray = [...fields];
    if (youtubeRegex.test(data)) {
      fieldsArray[index].url = data;
      setFields(fieldsArray);
    } else {
      setError("Youtube URL is required");
    }
  };

  const handleDelete = () => {
    let fieldsArray = [...fields];
    const storingArray = fieldsArray.filter(
      (field) => field.key !== deleteIndex
    );
    setFields(storingArray);
    setConfirmationPopup(false);
    setWarning("You Have Deleted Please Save The Changes Before Closing It.");
    setDeleteIndex(null);
  };
  const handleErrorCheck = (data, index) => {};
  const handleUrlCheck = (data, index) => {
    if (!youtubeRegex.test(data)) {
      setError("Youtube URL is required");
    } else {
      setError(false);
    }
  };
  const handleAddField = () => {
    let fieldsArray = [...fields];
    fieldsArray.push({ key: uid(8), player: "", url: "" });
    setFields(fieldsArray);
  };
  let exists = null;
  exists = fields.map((field, index) => {
    return (
      <>
        <li key={field.key}>
          <Button
            id={index}
            color="red"
            className="delete-li"
            name="RemovePlayerButton"
            onClick={() => {
              setDeleteIndex(field.key);
              setConfirmationPopup(true);
            }}
          >
            <Icon name="minus" />
          </Button>
          <Grid divided="vertically">
            <Grid.Row stackable="true" columns={2}>
              <Grid.Column mobile={16} tablet={8} computer={8}>
                <Form.Field>
                  <label>Select player</label>
                  <PlayersDropdown
                    clearable
                    onBlur={(e, data) => handleErrorCheck(data, index)}
                    name={`playerDropdown${index}`}
                    onChange={(e, data) => {
                      handleDropdownChange(data, index);
                    }}
                    defaultValue={field ? field.player : null}
                    placeholder={fields ? field.player : "Select Name"}
                  />
                </Form.Field>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={8} computer={8}>
                <Form.Field>
                  <label>Youtube URL</label>
                  <input
                    placeholder="https://youtube.com"
                    id={`urlInput${index}`}
                    onChange={(e) => {
                      handleUrlChange(e.target.value, index);
                    }}
                    defaultValue={field ? field.url : ""}
                    onBlur={(e) => handleUrlCheck(e.target.value, index)}
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </li>
      </>
    );
  });
  return (
    <div className="AdminTopButtonsProgressContainer player-modal">
      <div className="AdminTopButtonsContainer d-custom">
        {!warning && (
          <Button
            floated="left"
            circular
            icon="close"
            onClick={props.onClose}
          />
        )}
        {warning && (
          <Button
            disabled
            floated="left"
            circular
            icon="close"
            onClick={props.onClose}
          />
        )}
        <div className="d-CustomInnderdiv">
          {close && (
            <span className="successPlayerToWatch">
              Added <BsFillPatchCheckFill size={16} />
            </span>
          )}
          {!error && (
            <Button
              floated="right"
              positive
              name="saveButton"
              content="Save"
              labelPosition="right"
              icon="checkmark"
              onClick={handleSubmit}
            />
          )}
          {error && (
            <Button
              floated="right"
              disabled
              name="saveButton"
              content="Save"
              labelPosition="right"
              icon="checkmark"
              onClick={handleSubmit}
            />
          )}
        </div>
      </div>
      <div className="AdminFormContainer">
        <Form>
          <div className="AdminFormPersonalInfoContainer">
            <h3>Players To Watch</h3>

            {fields && <ul>{exists}</ul>}
            {warning && <p style={{ color: "#FF6600" }}>{warning}</p>}
            {error && <p style={{ color: "#800000" }}>{error}</p>}
            <Button
              icon
              labelPosition="left"
              color="green"
              name="AddPlayerButton"
              onClick={() => {
                handleAddField();
              }}
            >
              <Icon name="plus" />
              Add player
            </Button>
          </div>
        </Form>
      </div>
      {confirmationPopup && (
        <Modal className="delete-popup" open={confirmationPopup}>
          <Modal.Content>
            <p className="p1">Are you sure want to delete this Field?</p>
            <p className="p2">This process cannot be undone.</p>
            <div className="delete-modal-footer">
              <Button
                name="closeButton"
                content="Cancel"
                onClick={() => {
                  setConfirmationPopup(false);
                  setDeleteIndex(null);
                }}
              />
              <Button
                color="red"
                name="saveButton"
                content="Delete"
                onClick={handleDelete}
              />
            </div>
          </Modal.Content>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    close: state.athlete.playerToWatchAdded,
    DataplayersToWatch: state.firestore.data.playerstowatch,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "playerstowatch",
    },
  ])
)(NewPlayersToWatch);
